// libraries
import { useTranslation } from "react-i18next";

// components & functions
import Breadcrumb from "../../components/Breadcrumb";

import support from "../../../assets/img/utils/support.png"

const CagriMerkezi = () => {

    const { t } = useTranslation();

    const breadcrumb = [
        {
            id: 1,
            link: "/elaqe/cagri-merkezi",
            title: t('contact:cagri'),
            isActive: true,
        },
        {
            id: 2,
            link: "/elaqe/elaqe-vasiteleri",
            title: t("contact:contact"),
            isActive: false,
        },
        {
            id: 3,
            link: "/elaqe/metbuat-xidmeti",
            title: t("contact:press"),
            isActive: false,
        },
        {
            id: 4,
            link: "/elaqe/en-cox-verilen-suallar",
            title: t("contact:faq"),
            isActive: false,
        },
    ];

    return (
        <div className="contact-page block-bg1 pt-lg-3 pb-3">
            <Breadcrumb data={breadcrumb} />

            <div className="container mt-4 mt-sm-2">
                <h1 className="text text-center section-heading mb-4 mb-lg-5 mt-5 mt-lg-1">{t('contact:cagri')}</h1>
                <p className="t-color5">{t('contact:cagri_text')}</p>
                <div className="row flex-nowrap align-items-center mt-4">
                    <img src={support} alt="Support" className="col-3 col-md-1" />
                    <h5 className="t-color5 mb-0 p-0">{t('contact:cagri')}</h5>
                </div>
            </div>
        </div>
    );
};

export default CagriMerkezi;
